module.exports = __webpack_public_path__ + "img/avatar-none.025d91ee.png";